import { GLOBAL_SCOPE as o } from "./constants.js";
function s(e) {
  return {
    scope: e.scope,
    id: e.id,
    name: e.name,
    description: e.description,
    shortcut: e.shortcut
  };
}
function f(e, n) {
  return e.bindings[n] ?? [];
}
function r(e, n) {
  return e.compiledBindings[n] ?? [];
}
function p(e, n) {
  return e.acceptedEventKeys.every((t) => n.has(t));
}
function a(e, n) {
  const t = r(e, n);
  if (n === o)
    return t.map(s);
  const c = r(e, o), i = new Set(
    t.flatMap((d) => d.acceptedEventKeys)
  );
  return [
    ...t.map(s),
    ...c.filter((d) => !p(d, i)).map(s)
  ];
}
function l(e, n, t) {
  const c = r(e, n).find(
    (i) => i.acceptedEventKeys.includes(t)
  );
  if (c)
    return c;
  if (n !== o)
    return r(e, o).find(
      (i) => i.acceptedEventKeys.includes(t)
    );
}
export {
  l as findBinding,
  a as getActiveBindingsForScope,
  f as getBindingsForScope,
  s as toResolvedBinding
};
